// extracted by mini-css-extract-plugin
module.exports = {"profilePhoto":"styles_profilePhoto__J0zpE","text":"styles_text__Gh8Q9","trailPhoto":"styles_trailPhoto__sKJ2J","subtext":"styles_subtext__6B_pM"};